import { Linkable } from '@/components/blocks/Linkable';
import { Stack, Typography } from '@mui/material';

export const LegendFooter: React.FC = () => (
	<Stack direction={'row'} mt={'10px'} mb={'40px'}>
		<Typography sx={{ fontSize: 'var(--font-size-micro)' }}>
			{
				'Los plazos disponibles y definitivos para tu compra, se activarán en base al monto total que pagues con tu dpvale, consulta términos y condiciones en: '
			}
			<Linkable
				href={'https://www.dportenis.mx/terminos-promocionesdp'}
				target="_blank"
				sx={{
					fontSize: 'var(--font-size-micro)',
					textDecoration: 'underline',
				}}
			>
				{'https://www.dportenis.mx/terminos-promocionesdp'}
			</Linkable>
		</Typography>
	</Stack>
);
